import { Pagination } from 'src/types';
import { IAlert } from 'src/types/alerts';

export const SET_ETHOCA_ALERTS = 'SET_ETHOCA_ALERTS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_LOADING = 'SET_LOADING';

export type SetEthocaAlerts = {
    type: typeof SET_ETHOCA_ALERTS;
    payload: IAlert[];
};

export type SetPagination = {
    type: typeof SET_PAGINATION;
    payload?: Pagination;
};

export type SetLoading = {
    type: typeof SET_LOADING;
    payload: boolean;
};

export type EthocaAlertsActionTypes =
    | SetEthocaAlerts
    | SetLoading
    | SetPagination;

export const setEthocaAlertsAction = (
    verifiAlerts: IAlert[]
): SetEthocaAlerts => ({
    type: SET_ETHOCA_ALERTS,
    payload: verifiAlerts
});

export const setPaginationAction = (
    pagination?: Pagination
): SetPagination => ({
    type: SET_PAGINATION,
    payload: pagination
});

export const setLoadingAction = (loading: boolean) => ({
    type: SET_LOADING,
    payload: loading
});
